var map = {
	"./Ochoose.svg": "6508",
	"./Original_blue1.svg": "41ba",
	"./icon_fault.svg": "9111",
	"./icon_line_photo.svg": "e9f5",
	"./pay_loading.svg": "bfd7",
	"./riginal_gray.svg": "ab9f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "add1";